<router-outlet></router-outlet>
<cck-loader *ngIf="isLoading"></cck-loader>
